import { NgModule } from '@angular/core';

import { SharedModule }       from '../shared/shared.module';
import { SyncXeroComponent }  from './xero.sync.component';
import { XeroErrorComponent } from './xero.error.component';
import { XeroService }        from './xero.service';

@NgModule({
  declarations: [
    SyncXeroComponent,
    XeroErrorComponent
  ],
  entryComponents: [
    SyncXeroComponent,
    XeroErrorComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    XeroService
  ]
})
export class XeroModule {}
